import MeetYourHost from "./meet-your-host";

export default function MeetYourHostContainer() {
  return (
    <div className="flex w-screen justify-center relative pb-12   ">
      <div className="w-full px-6 7:px-10 11:px-20 13:px-0 relative 13:w-c1120 flex ">
        <MeetYourHost />
      </div>
    </div>
  );
}
